<template>
  <div>
    <b-overlay
      :show="loadTeachers"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="md"
    > 
      <div class="d-flex" style="height: 200px">
        <div class="courseNames w-50">
          <!-- Case 1: infrastructure_feedback → Show checkboxes -->
          <div v-if="survey.survey_type == 'infrastructure_feedback'" class="p-2 border rounded" style="max-height: 200px; overflow-y: auto;">
            <div
              v-for="(subgroup, index) in subgroupForProgramExitSurvey"
              :key="index"
              class="d-flex align-items-center mb-1"
            >
             
              <input
                type="checkbox"
                :id="'subgroup_' + index"
                :value="subgroup.value"
                v-model="selectedSubgroups"
                @change="getsubgroupStudents()"
                class="mr-2"
              />
              <label :for="'subgroup_' + index" class="m-0" style="cursor: pointer;">{{ subgroup.text }}</label>
            </div>
          </div>

          <!-- Case 2: All other surveys → Normal single select -->
          <b-form-select
            v-else
            :options="subgroupForProgramExitSurvey"
            v-model="subgroupId"
            @change="getsubgroupStudents()"
            :disabled="disableChange"
          ></b-form-select>
        </div>

        <!-- Selected Students Display -->
        <div
          class="courseUsers w-50"
          v-if="subgroupUsers.length != 0"
          style="overflow-y: scroll"
        >
          <div class="d-flex flex-wrap">
            <p
              v-for="(student, studentIndex) in subgroupUsers"
              :key="studentIndex"
              class="bg-success p-1 text-white rounded ml-2"
              style="font-size: 12px; font-weight: 600"
            >
              {{ student.first_name || " " }} {{ student.last_name || " " }}
            </p>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: [
    "subgroupForProgramExitSurvey",
    "surveyId",
    "survey",
    "disableChange",
  ],
  async created() {
    if (this.survey.id && this.survey.usersubgroup_ids && this.survey.usersubgroup_ids.length > 0) {
      this.selectedSubgroups = this.survey.usersubgroup_ids;

      await this.getsubgroupStudents();
    }
    if (this.survey.id && this.survey.usersubgroup_id) {
      this.subgroupId = this.survey.usersubgroup_id;

      await this.getsubgroupStudents();
    }
  },
  data() {
    return {
      loadTeachers: false,
      subgroupId: null,
      selectedSubgroups: [], // for multi-select checkboxes
      subgroupUsers: [],
    };
  },
  methods: {
    async getsubgroupStudents() {
      this.loadTeachers = true;
      this.subgroupUsers = [];

      // Handle both single & multi subgroup selection
      let subgroupIds = [];
      if (this.survey.survey_type == "infrastructure_feedback") {
        subgroupIds = this.selectedSubgroups;
      } else if (this.subgroupId) {
        subgroupIds = [this.subgroupId];
      }

      // Emit selected IDs (for parent component)
      await this.$emit("setUserSubgroupId", subgroupIds);

      // Fetch students for each subgroup
      const userPromises = subgroupIds.map((id) => {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${id}/users`;
        return this.$axios.get(url);
      });

      try {
        const responses = await Promise.all(userPromises);
        let allUsers = [];
        responses.forEach((res) => {
          allUsers = allUsers.concat(
            res.data.filter(
              (subgroup) => subgroup.pivot.usersubgrouprole_id == 2
            )
          );
        });
        this.subgroupUsers = allUsers;
      } catch (error) {
        console.error("Error fetching subgroup students:", error);
      } finally {
        this.loadTeachers = false;
      }
    },
  },
};
</script>
